module.exports = __webpack_public_path__ + "img/bg1@2x.36eb705b.jpg";